import React, { useEffect, useState } from "react";
import "./Board.css";
import { supabase } from "../../services/db";
import { Link, useParams } from "react-router-dom";
import FoodSection from "./FoodSection";
import Modal from "../../components/Modal/Modal";
import { useNavigate } from "react-router-dom";

const DeleteBoardContent = ({ onSubmit }) => {
  return (
    <div className="flexColoumn">
      <div className={"flexEnd"}>
        <button onClick={onSubmit}>Delete</button>
      </div>
    </div>
  );
};

const ModalContent = ({ handleClose, onSubmit }) => (
  <form
    onSubmit={(event) => {
      const name = event.target.elements.name?.value;
      const description = event.target.elements.description?.value;
      if (name) {
        onSubmit({ name, description }).then(() => handleClose());
      }
      event.preventDefault();
    }}
  >
    <fieldset className="flexColumn">
      <legend>Section</legend>
      <div>
        <label className="Label" htmlFor="name">
          Name
        </label>
        <input id="name" defaultValue="Food" />
      </div>
      <div>
        <label className="Label" htmlFor="name">
          Description
        </label>
        <input id="description" />
      </div>
    </fieldset>
    <div className="flexEnd">
      <button type="submit">Submit</button>
    </div>
  </form>
);

const Board = () => {
  const { boardId } = useParams();
  const [foodSections, setFoodSections] = useState([]);
  const [boardInfo, setBoardInfo] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    getSections(boardId);
    getBoardInfo(boardId);
  }, [boardId]);

  const getBoardInfo = async (boardId) => {
    if (!boardId) {
      return;
    }
    const { data, error } = await supabase()
      .from("Boards")
      .select()
      .eq("id", boardId)
      .limit(1)
      .single();
    if (error) {
      return;
    }
    setBoardInfo(data);
  };

  async function getSections(boardId) {
    const { data } = await supabase()
      .from("Section")
      .select()
      .eq("boardId", boardId);
    data && setFoodSections(data);
    console.log("data", data);
  }

  const addSection = async ({ name, description }) => {
    await supabase().from("Section").insert({ name, description, boardId });
    await getSections(boardId);
  };

  const deleteBoard = async (handleClose) => {
    const { error } = await supabase()
      .from("Section")
      .delete()
      .eq("boardId", boardId);
    if (error) {
      console.error(error);
      return;
    }
    await supabase().from("Boards").delete().eq("id", boardId);
    handleClose();
    navigate("/");
  };

  return (
    <div className="defaultPageContainer">
      <Link to="/">View all boards</Link>
      <div className="flex">
        <h2 className="flex1">{boardInfo?.name}</h2>
        <Modal
          title={"Add Section"}
          buttonContent="Add Section"
          description="Create a new section to store recipes"
          content={(handleClose) => (
            <ModalContent handleClose={handleClose} onSubmit={addSection} />
          )}
        />
        <Modal
          title={`Delete board - ${boardInfo?.name}`}
          buttonContent="Delete Board"
          description="This will delete the board and related sections. Recipes will still be visible in 'All Recipes'"
          content={(handleClose) => (
            <DeleteBoardContent onSubmit={() => deleteBoard(handleClose)} />
          )}
        />
      </div>
      {foodSections.length === 0 && (
        <div>
          <p>Create a section to get started</p>
          <Modal
            title={"Add Section"}
            buttonContent="Add Section"
            description="Create a new section to store recipes"
            content={(handleClose) => (
              <ModalContent handleClose={handleClose} onSubmit={addSection} />
            )}
          />
        </div>
      )}
      {foodSections.map((section) => (
        <FoodSection
          id={section.id}
          sectionName={section.name}
          key={section.id}
          description={section.description}
        />
      ))}
    </div>
  );
};
export default Board;
